export default __webpack_public_path__ + "resources/icons/d103-25a3.png";